export const TOGGLE_FLAG_POP_UP =
  process.env.REACT_APP_TOGGLE_FLAG_POP_UP === 'true';

export const TOGGLE_REQUEST_GENDER =
  process.env.REACT_APP_TOGGLE_REQUEST_GENDER === 'true';

export const TOGGLE_CLUBE_PARCERIAS =
  process.env.REACT_APP_TOGGLE_CLUBE_PARCERIAS === 'true';

export const TOGGLE_HOME_AFASTAMENTO_POPUP =
  process.env.REACT_APP_TOGGLE_HOME_AFASTAMENTO_POPUP === 'true';

export const TOGGLE_SATISFACTION_SURVEY =
  process.env.REACT_APP_TOGGLE_SATISFACTION_SURVEY === 'true';
